import PropTypes from 'prop-types';
import React from 'react';
import {
    Container,
    Title
} from './styled';

const PanelSection = ({ children, title }) => (
    <Container>
        <Title>{ title }</Title>
        { children }
    </Container>
);

PanelSection.propTypes = {
    children: PropTypes.any,
    title: PropTypes.string
};

PanelSection.defaultProps = {
    title: ''
};
PanelSection.displayName = 'PanelSection';

export default PanelSection;
